import { PlatformPageShell } from "../../design/shell";
import { useProfilePlatformFonts } from "../profile/hooks/useProfilePlatformFonts";
import { useScrollRegSurfaceToTop } from "../match/shell/hooks/useScrollRegSurfaceToTop";
import "../profile/styles/profileClaude.module.css";
import c from "../profile/styles/profileClaude.module.css";
import i from "./infoPageProfile.module.css";

/**
 * About / Privacy / Feedback — Explore Organizations chrome (`PlatformPageShell`).
 * @param {{ children: import("react").ReactNode; title?: string; backTo?: string }} props
 */
export default function InfoPageShell({ children, title, backTo = "/profile" }) {
  useProfilePlatformFonts();
  const surfaceRef = useScrollRegSurfaceToTop();

  return (
    <PlatformPageShell title={title} headerIcon="info" backFallback={backTo} testId="info-page-shell">
      <div className={`${c.pp} ${i.wrap}`} ref={surfaceRef}>
        {children}
      </div>
    </PlatformPageShell>
  );
}
